<template>
    <div class="card" style="min-height: calc(100vh - 180px)">
        <div class="bg-blue-light p-1">
            <TitleButton
                btnTitle="List"
                :showBtn="true"
                :showAddNew="false"
                title="Sales Order Add"
                @onClickCloseButton="navigateToListPage"
            />

            <div class="row gy-1">
                <div class="col-md-3">
                    <label class="form-label">Order Date</label>
                    <input
                        class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                        tabindex="1"
                        type="date"
                        placeholder=""
                        v-model="formData.date"
                    >
                </div>
                <div class="col-md-3" v-if="false">
                    <label class="form-label">Order No</label>
                    <div class="d-flex align-items-center justify-content-md-end mb-1">
                        <div class="input-group input-group-merge invoice-edit-input-group">
                            <div class="input-group-text">
                                <span>{{ prefix }}-</span>
                            </div>
                            <input type="number" min="1" class="form-control invoice-edit-input" placeholder=""
                                   v-model="serial">
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mt-tpp-1">
                    <label class="form-label">Select BDO</label>
                    <AsyncSelect
                        placeholder="Select BDO"
                        v-model="singleSR"
                        :api-service="fetchAllSR"
                        :additional-option="additionalSROption"
                    />
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mt-tpp-1">
                    <label for="colFormLabel" class="form-label">Bank-Branch</label>
                    <AsyncSelect
                        placeholder="Select Bank-Branch"
                        v-model="singleDealer"
                        :api-service="fetchAllDealers"
                        :additional-query="additionalDealerQuery"
                        :additional-option="additionalDealerOption"
                        :key="dealerRenderKey"
                        :disabled="! Boolean(singleSR)"
                    />
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                    <div class="d-flex align-items-center justify-content-between filter-label">
                        <label for="colFormLabel" class="form-label">Customer Name </label>
                    </div>
                    <v-select
                        placeholder="Customer Name"
                        v-model="contactProfile"
                        :api-service="fetchContactProfiles"
                        disabled
                    />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Project</label>
                    <v-select
                        placeholder="Select Project"
                        v-model="formData.project_id"
                        :options="projects"
                        label="name"
                        :reduce="name => name.id"
                        disabled
                    />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Business Unit</label>
                    <v-select
                        placeholder="Select Business"
                        v-model="formData.business_id"
                        :options="business"
                        label="name"
                        :reduce="name => name.id"
                        disabled
                    />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Cost Centre</label>
                    <v-select
                        placeholder="Select Cost Centre"
                        v-model="formData.cost_centre_id"
                        :options="costCentres"
                        label="name"
                        :reduce="name => name.id"
                    />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Order No/PI No</label>
                    <input
                        class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                        tabindex="1"
                        type="text"
                        placeholder="Please add order number"
                        v-model="formData.order_number"
                    >
                </div>
                <div class="col-md-3">
                    <label class="form-label">Sales Person</label>
                    <v-select
                        v-model="salesPerson"
                        disabled
                    />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Commission %</label>
                    <input
                        class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                        tabindex="1"
                        type="number"
                        placeholder="Please add commission %"
                        v-model="formData.commission_percent"
                    >
                </div>
                <div class="col-md-3">
                    <label class="form-label">LC No</label>
                    <input
                        class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                        tabindex="1"
                        type="text"
                        placeholder="Please add LC number"
                        v-model="formData.lc_number"
                    >
                </div>
                <div class="col-md-3">
                    <label class="form-label">Order Type</label>
                    <v-select
                        placeholder="Select Order Type"
                        v-model="formData.sale_type"
                        :options="orderTypes"
                        label="name"
                        :reduce="name => name.value"
                    />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Ship from (Warehouse)</label>
                    <v-select
                        placeholder="Select Warehouse Location"
                        v-model="formData.location_id"
                        :options="locations"
                        label="text"
                        :reduce="text => text.id"
                    />
                </div>
            </div>
        </div>

        <div class="px-2">
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" data-bs-toggle="tab"  aria-controls="home" role="tab" aria-selected="true">Item Details</a>
                </li>
            </ul>
        </div>

        <div class="px-3">
            <Invoice
                class="mt-2"
                v-for="(data, index) in itemsDetails"
                v-show="data && data.show_item"
                :key="data.id || index"
                :index="index"
                :data="data"
                :accountHeads="accountHeads"
                :vatRate="vatRate"
                :isItem="isItem"
                :isSaleOrder="true"
                :locationId="formData.location_id"
                :business="business"
                :projects="projects"
                :costCentres="costCentres"
                :isQuotation="true"
            />
        </div>

        <div class="px-2">
            <div class="row justify-content-end">
                <div class="col-12 col-sm-3">
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-4">
                                    <label class="col-form-label" for="first-name">Sub total</label>
                                </div>
                                <div class="col-sm-8">
                                    <input
                                        v-model="subTotal"
                                        readonly
                                        type="text"
                                        class="form-control text-right"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-4">
                                    <label class="col-form-label" for="first-name">VAT</label>
                                </div>
                                <div class="col-sm-8">
                                    <input
                                        v-model="totalVAT"
                                        readonly
                                        type="text"
                                        class="form-control text-right"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-4">
                                    <label class="col-form-label" for="first-name">Total</label>
                                </div>
                                <div class="col-sm-8">
                                    <input
                                        v-model="total"
                                        readonly
                                        type="text"
                                        class="form-control text-right"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-4">
                                    <label class="col-form-label" for="first-name">Discount / Round up Adj</label>
                                </div>
                                <div class="col-sm-8">
                                    <input
                                        v-model.trim="formData.adjustment_amount"
                                        type="number"
                                        class="form-control form-control-sm discount-adj ml-auto text-right"
                                        placeholder="amount" :min="0"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12" v-if="discountAmount > 0">
                            <div class="mb-1 row">
                                <div class="col-sm-4">
                                    <label class="col-form-label" for="first-name">Select discount head</label>
                                </div>
                                <div class="col-sm-8">
                                    <v-select
                                        placeholder="Select Discount Head"
                                        v-model="formData.discount_head_id"
                                        :options="salesAccountHeads"
                                        label="name"
                                        :reduce="name => name.id"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-4">
                                    <label class="col-form-label" for="first-name">Net Bill</label>
                                </div>
                                <div class="col-sm-8">
                                    <input
                                        v-model.trim="grandTotal"
                                        type="number" class="form-control form-control-sm discount-adj ml-auto text-right"
                                        placeholder="amount" :min="0"
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 px-2">
            <div class="mb-1">
                <label class="form-label" for="description">Memo</label>
                <vField
                    as="textarea"
                    name="description"
                    type="number"
                    class="form-control"
                    v-model="formData.description"
                />
            </div>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1 px-2">
            <label class="form-label">Attachment</label>
            <BlobFileViewer :attachments="formData.attachments" />
            <FileUpload
                :is-drag-active="true"
                button-text="Upload Documents"
                v-model="formData.attachments"
            >
            </FileUpload>
        </div>

        <div class="pb-5 px-2 mt-4">
            <div class="d-flex flex-wrap gap-1 gy-2">
                <button :disabled="saveButtonLoader" @click="handleSubmit()" class="btn btn-primary">Save</button>
                <button :disabled="productLoader" @click="navigateToListPage" class="btn btn-outline-secondary">Cancel</button>
            </div>
        </div>
         <Loader v-if="loader"/>
    </div>
</template>

<script setup>
import { ref, inject, onMounted, computed, watch } from 'vue'
import {vatRate} from '@/data/inventory.js'
import { useRouter, useRoute } from 'vue-router'
import handlePurchase from '@/services/modules/purchase'
import handleCBusinesses from '@/services/modules/businesses'
import handleBusinessesLocations from '@/services/modules/businessesLocations'
import handleContact from '@/services/modules/contact'
import handleCostCentres from "@/services/modules/ngo/costCentre";
import handleProjects from "@/services/modules/procurement/project";
import Loader from '@/components/atom/LoaderComponent'
import TitleButton from '@/components/atom/TitleButton'
import Invoice from '@/components/molecule/company/inventory/sales/Invoice.vue'
import {generateTxnNumber} from "@/services/utils/voucherNumberGenerator";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleCrm from '@/services/modules/crm/crm'
import handleAdmin from '@/services/modules/admin/admin';
import handleDropdowns from '@/services/modules/dropdowns';
import FileUpload from "@/components/atom/FileUpload";
import BlobFileViewer from "@/components/atom/BlobFileViewer";

const router = useRouter()
const route = useRoute()
let prefix = ref('')
let serial = ref('')
const singleSR = ref(null);
const singleDealer = ref(null);
const dealerRenderKey = ref(0);
const contactRenderKey = ref(0);

const showError =  inject('showError');
const showSuccess =  inject('showSuccess');

const {fetchProductList, fetchAccountHead, ...rest} = handlePurchase()
const {fetchContactProfiles, fetchSingleContactProfile } = handleContact()
const { fetchAllDealers, fetchAllSR } = handleCrm();
const { fetchQuotationById, formatFormData, handleAttachments } = handleAdmin();
const { fetchDropdownList } = handleDropdowns();

const additionalDealerQuery = ref({});
const additionalContactOption = ref({
    with_mobile: 1,
    with_donors: 1,
    dealer_id: '',
    roles: 'customer,lead'
});
const additionalDealerOption = ref([]);
const additionalSROption = ref([]);

const companyId = computed(() => {
    return route.params.companyId
})

const orderTypes = ref([])

let loader =ref(false)
let productLoader =ref(false)
let saveButtonLoader=ref(false)
let accountHeads = ref([])
let business = ref([])
let locations = ref([])
let accountPayable = ref([])
let vatPayable = ref([])
let projects = ref([])
let costCentres = ref([])
let salesAccountHeads = ref([])
const contactProfile = ref(null);
const grandTotal = ref(null);
const salesPerson = ref(null);

onMounted(async () => {
    loader.value=true
    let voucher = await generateTxnNumber(`?company_id=${route.params.companyId}&voucher_type=journal_voucher&txn_type=invoice_order`);
    prefix.value = voucher.prefix;
    serial.value = voucher.serial;
    formData.value.date =  new Date().toISOString().split('T')[0]
    const quotationId = route.params.quotationId;

    const companyQuery = `?company_id=${companyId.value}`;
    const quotationRes = fetchQuotationById(quotationId, companyQuery);
    const dropdownRes = fetchDropdownList(getDropDownQuery());

    Promise.all([
        quotationRes.then(res => {
            if(res.data) {
                formData.value = res.data;
                formData.value.item_details = res.data.quotation_generals && res.data.quotation_generals.map(item => ({
                    ...item,
                    product: {
                        id: item.product_id,
                        name: item.product_name
                    },
                    show_item: true
                })) || [];
                formData.value.has_item_detail = true;
                contactProfile.value = {
                    id: res.data.contact_profile_id,
                    label: res.data.contact_profile_name
                }
                salesPerson.value = {
                    id: res.data.sales_person_id,
                    label: res.data.sales_person_name
                };
            }
        }),
        dropdownRes.then(res => {
            if(res.data) {
                business.value = res.data.business_list || [];
                costCentres.value = res.data.cost_centre_list || [];
                salesAccountHeads.value = res.data.account_head_list_by_slag.sales_accounts || [];
                orderTypes.value = res.data.sale_type_list || [];
                accountPayable.value = res.data.account_head_list_by_slag.accounts_receivable || [];
                vatPayable.value = res.data.account_head_list_by_slag.vat_payable || [];
                locations.value = res.data.business_location_list || [];
                projects.value = res.data.project_list || [];

                if(orderTypes.value.length) {
                  formData.value.sale_type = orderTypes.value[0].value;
                }

                if(vatPayable.value.length) {
                    formData.value.vat_payable_account_head_id = vatPayable.value[0].id
                }

                if(accountPayable.value.length) {
                    formData.value.account_head_id = accountPayable.value[0].id
                }
            }
        }),
    ])
    .then(() => {
        loader.value=false
    })
    .catch(()=>{loader.value=false})
})

let formData = ref({
    company_id: companyId,
    contact_profile_id: null,
    account_head_id: null,
    vat_payable_account_head_id: null,
    business_id: null,
    project_id: null,
    cost_centre_id: null,
    discount_head_id: null,
    location_id: null,
    status: 'pending',
    bill_number: '',
    date: '',
    has_item_detail: true,
    description: '',
    order_number: null,
    sales_person_id: null,
    commission_percent: null,
    lc_number: null,
    sale_type: null,
    adjustment_amount: null,
    attachments: [],
    item_details: [
        {
            product_id: null,
            alt_unit_qty: null,
            alt_unit_id: null,
            quantity: 1,
            free_quantity: 0,
            rate: '',
            vat: 0,
            vat_amount: 0,
            description: "",
            discount_amount: 0,
            offer_discount: 0,
            discount_percent: 0,
            business_id: null,
            project_id: null,
            cost_centre_id: null
        }
    ],
  route_name:'sales-order-add',
})

const hasItemDetails = computed(() => {
    return formData.value.has_item_detail
})

const itemsDetails = computed(() => {
  return [...(formData.value.item_details || [])];
});

const isItem = computed(() => {
    return formData.value.has_item_detail ? true : false
})

const discountAmount = computed(() => formData.value.adjustment_amount);

const subTotal = computed(() => {
    let total = 0;

    formData.value.item_details.forEach(item => {
        const qty = parseFloat(item.quantity) || 0;
        const rate = parseFloat(item.rate) || 0;
        const discount = parseFloat(item.discount_amount) || 0;
        const offerDiscount = parseFloat(item.offer_discount) || 0;

        total += (qty * rate) - discount - offerDiscount;
    });

    return total.toFixed(4);
});

const totalVAT = computed(() => {
    let vat = 0
    formData.value.item_details.map(item => {
        if(item.vat_amount) {
            vat += parseFloat(item.vat_amount)
        }
    })

    return vat.toFixed(2)
})

const total = computed(() => {
    return (parseFloat(subTotal.value) + parseFloat(totalVAT.value)).toFixed(4);
})

watch(discountAmount, (newValue, oldValue) => {
    if (! newValue || newValue < 0) {
        grandTotal.value = total.value;
        formData.value.adjustment_amount = null;
        return;
    }

    if (newValue !== oldValue) {
        grandTotal.value = total.value - discountAmount.value
    }
})

watch(total, () => {
    grandTotal.value = total.value - discountAmount.value;
})

watch(grandTotal, (newValue, oldValue) => {
    if (newValue !== oldValue) {
        formData.value.adjustment_amount = parseFloat((total.value - newValue).toFixed(4));
    }
})

watch(() => singleSR.value, (newValue) => {
    additionalDealerQuery.value = {};
    additionalContactOption.value.dealer_id = '';
    singleDealer.value = null;
    contactProfile.value = null;
    formData.value.contact_profile_id = null;
    dealerRenderKey.value += 1;
    contactRenderKey.value += 1;

    if(newValue) {
        additionalDealerQuery.value = {'sale_representative_id': newValue.id}
        formData.value.sales_person_id = {
          id: newValue.id,
          name: newValue.name
        }
    }
})

watch(() => singleDealer.value, (newValue) => {
    additionalContactOption.value.dealer_id = '';
    contactProfile.value = null;
    formData.value.contact_profile_id = null;
    contactRenderKey.value += 1;

    if(newValue) {
        additionalContactOption.value.dealer_id = newValue.id
    }
})

watch(hasItemDetails, (newValue) => {
    formData.value.item_details = [{
        product_id: null,
        quantity: 1,
        rate: '',
        vat: 0,
        vat_amount: 0,
        description: "",
        discount_amount: 0,
        offer_discount: 0,
        discount_percent: 0,
        business_id: null,
        project_id: null,
        cost_centre_id: null
    }]
})

const getDropDownQuery = () => {
    let query = `?company_id=${companyId.value}
                &is_business=1
                &is_cost_centre=1
                &is_account_heads=1
                &is_sale_type=1
                &is_business_location=1
                &is_project=1
                &slags[]=sales_accounts
                &slags[]=accounts_receivable
                &slags[]=vat_payable`;

    return query;
}

function navigateToListPage() {
    router.push({
      name: 'edit-deal',
      params: {
        ...route.params,
        salePipelineId: route.query.dealId,
      },
      query: {
        ...route.query,
        tab: 'quotation',
      }
    })
}

function handleSubmit() {
    if (! formData.value.vat_payable_account_head_id){
      showError('Please select a vat payable account head');
      return;
    }

    if(contactProfile.value) formData.value.contact_profile_id = contactProfile.value.id;
    if(salesPerson.value) formData.value.sales_person_id = salesPerson.value.id;
    formData.value.bill_number = prefix.value+'-'+serial.value
    if(!formData.value.date) formData.value.date = new Date().toISOString().split('T')[0]
    formData.value.has_item_detail = 1;
    formData.value.quotation_master_id = route.params.quotationId;

    const payload = formatFormData(formData.value);
    if (formData.value.attachments && formData.value.attachments.length) {
        handleAttachments(payload, formData.value.attachments);
    }

    rest.createSalesOrder(payload)
    .then(res => {
        saveButtonLoader.value = false
        productLoader.value = false
        if(res.status) {
            showSuccess(res.message)
            navigateToListPage()
        }
        if(!res.status) {
            showError(res.message)
        }
    })
    .catch(() => {
        saveButtonLoader.value = false
    })
}
</script>

<style scoped>
.contact-detail {
    font-weight: 700;
    top: 12%;
    position: absolute;
}
.filter-label {
    padding-right: 0.5rem !important;
}
</style>